var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dialogBox"},[(_vm.popupModalShow)?_c('div',{staticClass:"dialog_box"},[(_vm.modalId === 0)?_c('TemplateModal',{attrs:{"textId":_vm.textId,"modalRow":_vm.modalRow},on:{"onConfirm":_vm.onConfirm,"closeModal":_vm.closeModal}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }